import React from "react";
import AuthLayout from "../components/layouts/AuthLayout";
import RegisterForm from "../auth/RegisterForm";
import { useAuth } from "../auth/AuthContext";
import { Navigate } from "react-router-dom";

const RegisterPage = () => {
  const { isAuthenticated } = useAuth();

  // Si el usuario ya está autenticado, redirigir al dashboard
  if (isAuthenticated) {
    return <Navigate to="/" />; // Redirigir a la raíz (dashboard)
  }

  return (
    <AuthLayout 
      title="Crear Compte" 
      subtitle="Registra't gratis ara."
    >
      <RegisterForm />
      <div className="mt-4 text-center">
        <p className="mb-0 text-muted">
          Ja tens compte?{" "}
          <a href="/login" className="fw-semibold text-primary text-decoration-underline">
            Inicia sessió
          </a>
        </p>
      </div>
    </AuthLayout>
  );
};

export default RegisterPage;
